(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('[data-edu-search]');
    const filters = [...root.querySelectorAll('[data-edu-filter]')];
    const terms = [...root.querySelectorAll('.edu-term')];
    const count = root.querySelector('[data-edu-count]');
    const empty = root.querySelector('.edu-empty');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    let category = 'all';
    const texts = terms.map(term => normalize(term.textContent));
    function update() {
      const query = normalize(input.value);
      let shown = 0;
      terms.forEach((term, i) => {
        const visible = (category === 'all' || term.dataset.category === category) && texts[i].includes(query);
        term.hidden = !visible;
        if (visible) shown++;
      });
      count.textContent = `${shown} ${shown === 1 ? 'término' : 'términos'} de ${terms.length}`;
      empty.hidden = shown !== 0;
    }
    input.addEventListener('input', update);
    filters.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.eduFilter;
      filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      update();
    }));
    root.querySelector('[data-edu-reset]').addEventListener('click', () => {
      input.value = '';
      category = 'all';
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.eduFilter === 'all')));
      update();
      input.focus();
    });
    root.querySelector('.edu-tools').hidden = false;
    update();
    function openTarget() {
      let id = '';
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      const target = id && terms.find(term => term.id === id);
      if (!target) return;
      if (target.hidden) {
        input.value = '';
        category = 'all';
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.eduFilter === 'all')));
        update();
      }
      target.open = true;
      requestAnimationFrame(() => window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 115 }));
    }
    openTarget();
    window.addEventListener('hashchange', openTarget);
  }
  document.querySelectorAll('[data-bf-education]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bf-education]').forEach(init));
})();

// Preselect a glossary filter from ?filtro=<value> (used by the home education pillars).
(function () {
  var filter = new URLSearchParams(location.search).get('filtro');
  if (!filter) return;
  function apply() {
    var btn = document.querySelector('[data-edu-filter="' + filter.replace(/[^a-z-]/g, '') + '"]');
    if (!btn) return;
    btn.click();
    var target = btn.closest('section') || btn;
    target.scrollIntoView({ block: 'start' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
